// extracted by mini-css-extract-plugin
module.exports = {"color-white":"theme_color-white__CDvyX","color-black":"theme_color-black__15jT5","color-default-gray":"theme_color-default-gray__2j0UY","default":"theme_default__3sIU6"};